export default "__VITE_ASSET__wn7zM42b__"